module.exports = __webpack_public_path__ + "img/16581244_S.130867df.png";